<template lang="pug">
  menu-bar-item(:label=`$t('frame')`)
    menu-item(:label=`$t('new_frame')`, @click="newFrame", keybind="alt+N")
    menu-item(:label=`$t('delte_frame')`, @click="deleteFrame", :disabled="Store.frames.length <= 1")
    menu-separator
    menu-item(:label=`$t('single')`, type="radio", v-model="Store.config.frame.mode", value="SINGLE")
    menu-item(:label=`$t('window')`, type="radio", v-model="Store.config.frame.mode", value="WINDOW")
    menu-separator
    menu-item(:label=`$t('lock')`, :disabled="Store.config.frame.mode == 'SINGLE'")
      menu-item(:label=`$t('wcs')`, v-model="Store.config.frame.lock.wcs")
    menu-separator
    menu-item(v-for="(frame, i) in Store.frames", :key="Id(frame)", :label="frame.name", type="radio", v-model="Store.currentFrameIndex", :value="i")
    menu-separator
    menu-item(:label=`$t('next_frame')`, keybind="Tab", @click="changeTab(+1)")
    menu-item(:label=`$t('previous_frame')`, keybind="shift+Tab", @click="changeTab(-1)")
</template>


<script lang="ts">
import Vue from 'vue'
import { store } from '@/store';
export default Vue.extend({
  methods: {
    newFrame() {
      store.addNewFrame()
      store.currentFrameIndex = store.frames.length - 1
    },
    deleteFrame() {
      if (confirm(this.$t('delete?', { frame_name: store.currentFrame.name }) as string)) {
        store.frames.splice(store.currentFrameIndex, 1)
      }
    },
    changeTab(d: number) {
      d += store.frames.length
      store.currentFrameIndex = (store.currentFrameIndex + d) % store.frames.length
    },
  },
})
</script>

<i18n>
en:
  frame: Frame
  new_frame: New Frame
  delte_frame: Delte Frame
  single: Single
  window: Window
  lock: Lock
  wcs: WCS
  next_frame: Next Frame
  previous_frame: Previous Frame
  delete?: 'Are you sure to close frame "{frame_name}"'
ja:
  frame: フレーム
  new_frame: 新規
  delte_frame: 削除
  single: 単一フレーム
  window: ウインドウ
  lock: 固定
  wcs: WCS
  next_frame: 次
  previous_frame: 前
  delete?: '"{frame_name}"を削除しますか？'

</i18n>